import { ErrorBoundary } from "../../Common/ErrorBoundry";
import { ToolProps } from "../ActivityFeed/ActivityFeed";
import React, { Suspense, useState, } from 'react'
import { LinkApi } from "../../../redux/api/LinkApi";
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { EditBar } from "./EditBar";
import './Links.scss'

const LinksMenu = () => {
    const { data } = LinkApi.useGetLinksQuery();
    const [deleteLinkEndpoint] = LinkApi.useDeleteLinkMutation();
    const [editingLinkId, setEditingLinkId] = useState(null);

    const deleteLink = (id: number) => {
        deleteLinkEndpoint(id)
    }

    const systemLinks = data?.filter(l => l.Is_System);
    const myLinks = data?.filter(l => !l.Is_System);

    if (!data) return <div className="m-2">Loading...</div>

    return (
        <div className="links">
            <div className="links-list-div">
                {systemLinks?.length > 0 && <p className="title">System links</p>}
                <ul className="links-list">
                    {systemLinks.map((link) => (
                        <li
                            key={link.Link_Id}
                            title={link.Link}
                            onClick={(event) => {
                                // @ts-expect-error
                                if (event.target.tagName.toLowerCase() === "li")
                                    window.open(
                                        link.Link.match(/(http(s*):\/\/)/) === null ? "https://" + link.Link : link.Link
                                    );
                            }}
                        >
                            <div className="link-display">
                                <p className="list-item-title">{link.Link_Display}</p>
                            </div>
                        </li>))
                    }
                </ul>
                <p className="title">Your links</p>
                <ul>
                    {myLinks.map((link) => (
                        <li
                            key={link.Link_Id}
                            title={link.Link}
                            onClick={(event) => {
                                // @ts-expect-error
                                if (event.target.tagName.toLowerCase() === "li")
                                    window.open(
                                        link.Link.match(/(http(s*):\/\/)/) === null ? "https://" + link.Link : link.Link
                                    );
                            }}
                        >
                            {editingLinkId === link.Link_Id ? (
                                <EditBar link={link} setEditingLinkId={setEditingLinkId} newLink={false} />
                            ) : (
                                <div className="link-display">
                                    <p className="list-item-title">{link.Link_Display}</p>
                                    <div className="icons">
                                        <SvgIcon
                                            className="edit-link-btn icon"
                                            icon={svg.pencilIcon}
                                            onClick={() => setEditingLinkId(link.Link_Id)}
                                        />
                                        <SvgIcon
                                            className="delete-link-btn icon"
                                            icon={svg.trashIcon}
                                            onClick={() => deleteLink(link.Link_Id)}
                                        />

                                    </div>
                                </div>
                            )}
                        </li>
                    ))}
                    {editingLinkId === 0 ?
                        <EditBar link={{ Link_Id: 0, Contact_Id: 0, Link: "", Link_Display: "", Is_System: false }} setEditingLinkId={setEditingLinkId} newLink={true} /> :
                        <div title="Add new link" className="add-link-btn" onClick={() => setEditingLinkId(0)}>
                            <SvgIcon className="add-link-btn-icon" icon={svg.plusCircleIcon} />
                        </div>
                    }
                </ul>
            </div>
        </div>
    );
}

export const Links = (props: ToolProps) => {
    return (
        <section className='chat' onMouseLeave={props.onMouseLeave} >
            <ErrorBoundary errorMessage={<div className='m-5'><span className='k-font-icon k-i-close-circle' />Error: Failed to connect to chat service.</div>}>
                <Suspense fallback={'Loading...'}>
                    {/* LOCK ICON IS A FEW PIXELS SQUISHED!! */}
                    <header className='right-bar-header'><img className='icon' src='./images/Link-Out.png' /><span className='text'>Links</span>
                        {!props.fullScreen && <button className='icon lock' onClick={props.unlocked} title='Lock side-bar' ><img src='./images/Lock.png' style={{ alignContent: 'center' }} /></button>}
                        {!props.fullScreen && <button className='icon unlock' onClick={props.locked} title='Unlock side-bar' ><img src='./images/Unlock.png' style={{ alignContent: 'center' }} /></button>}
                    </header>

                    <LinksMenu />
                </Suspense>
            </ErrorBoundary>
        </section >
    )
}